import { PencilSquareIcon, ShieldExclamationIcon } from "@heroicons/react/24/outline";
import { arrayHasItems } from "../../helpers/common"
import { ConnectVariantButton } from "../common/ConnectVariantButton"
import ReactTooltip from "react-tooltip";
import { useEffect, useState } from "react";

const SingleBomSKU = ({
    bomVariantSku,
    access,
    onClickRemoveCallback,
    isDisabled
}) => {
    return (
        <div className="flex items-center gap-2">
            <span className="text-sm text-gray-900">{bomVariantSku}</span>
            {access === "edit" ? (
                <button
                    onClick={() => onClickRemoveCallback?.()}
                    disabled={isDisabled}
                    className="inline-flex items-center p-1 text-xs font-medium rounded hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:bg-gray-50"
                    aria-label="Remove bom SKU"
                >
                    <svg className="h-4 w-4 text-gray-500 hover:text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            ) : "|"}
        </div>
    )
}

export const BOMVariant = ({
    onClickVariantCallback,
    onClickRemoveCallback,
    onClickEdit,
    isLoading,
    access,
    isDisabled,
    skus,
    parentBomSkus
}) => {

    const showParentSkus = arrayHasItems(parentBomSkus) && !arrayHasItems(skus);

    useEffect(() => {
        ReactTooltip.rebuild()
    }, []);

    return (
        <div className="flex flex-col gap-2 mt-6">
            <div className="flex justify-between items-center">
                <div className="flex flex-row gap-2 items-center">
                    <h3 className="text-lg font-medium text-gray-900">BOM variant</h3>
                    {showParentSkus && (
                        <>
                            <ShieldExclamationIcon 
                                className="h-7 w-7 text-blue-700" 
                                data-for={`parent-bom_tooltip`}
                                data-tip={true}
                            />
                            <ReactTooltip 
                                id={`parent-bom_tooltip`} 
                                html={true}
                                effect='solid'
                            >
                                {`
                                    <div class="w-72 text-center py-1 px-1">
                                        The product variant has the parent BOM sku's.
                                    </div>
                                `}
                            </ReactTooltip>
                        </>
                    )}
                </div>
                {showParentSkus && access === "edit" && (
                    <button
                        className="flex flex-row gap-2 items-center bg-blue-500 text-white py-0.5 px-2 rounded hover:bg-blue-700"
                        onClick={() => {
                            onClickEdit?.();
                        }}
                    >
                    <span>Edit</span>
                        <PencilSquareIcon className="h-4 w-4" />
                    </button>
                )}
            </div>
            <div className="flex gap-2">
                {access === "edit" && (
                    <ConnectVariantButton
                        onClickCallback={onClickVariantCallback}
                        isLoading={isLoading}
                        isDisabled={showParentSkus}
                    />
                )}
                {arrayHasItems(skus) && (
                    <section className="flex gap-1 flex-wrap">
                        {skus.map((bomVariantSku) => {
                            return (
                                <SingleBomSKU
                                    key={bomVariantSku?.id}
                                    access={access}
                                    bomVariantSku={bomVariantSku?.sku}
                                    onClickRemoveCallback={() => onClickRemoveCallback?.(bomVariantSku?.id)}
                                    isDisabled={isDisabled || showParentSkus}
                                />
                            )
                        })}
                    </section>
                )}
                {showParentSkus && (
                    <section className="flex gap-1 flex-wrap">
                        {parentBomSkus.map((bomVariantSku) => {
                            return (
                                <SingleBomSKU
                                    key={bomVariantSku?.id}
                                    access={access}
                                    bomVariantSku={bomVariantSku?.sku}
                                    onClickRemoveCallback={() => onClickRemoveCallback?.(bomVariantSku?.id)}
                                    isDisabled={isDisabled || showParentSkus}
                                />
                            )
                        })}
                    </section>
                )}
            </div>
        </div>
    )
}